import { useState } from "react";
import { Button } from "@/components/ui/button";
import { HISTORY_REPORTS, ReportHistory } from "./ReportHistory";

// Dealer portal: pick one of the 5 history reports (own stores only)
export const DealerReportHistory = () => {
  const [report, setReport] = useState("dlar");
  return (
    <div className="space-y-3" data-testid="dealer-report-history">
      <div className="flex flex-wrap gap-2">
        {Object.entries(HISTORY_REPORTS).map(([k, r]) => (
          <Button key={k} size="sm" variant={report === k ? "default" : "outline"} onClick={() => setReport(k)} data-testid={`dealer-history-tab-${k}`}>{r.name} History</Button>
        ))}
      </div>
      <ReportHistory mode="dealer" report={report} key={report} />
    </div>
  );
};
